import { LOGIN_USER_SUCCESSFUL, LOGIN_PROCESSING, STOP_LOGIN_PROCESSING, LOGOUT_SUCCESSFUL } from "./type";

const defaultReducer = {
  isLoggedIn: false,
  processing: false,
  loginUser: null,
  loginData: null,
};

const loginReducer = (state = defaultReducer, action) => {
  switch (action.type) {
    case LOGIN_USER_SUCCESSFUL:
      return {
        ...state,
        processing: false,
        isLoggedIn: true,
        loginUser: action.payload,
      };

    case LOGIN_PROCESSING:
      return {
        ...state,
        processing: false,
      };

    case STOP_LOGIN_PROCESSING:
      return {
        ...state,
        processing: false,
      };

    case LOGOUT_SUCCESSFUL: {
      return {
        ...state,
        ...defaultReducer,
      };
    }

    default:
      return state;
  }
};

export default loginReducer;
